import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Container = styled(Flex)`
  flex-direction: column;
  flex: 1;

  overflow: hidden;
`;

export * as Header from './Header';
export * as Content from './Content';
